import {AdminRoutesPath} from "../adminRoutesPaths";
import {routes as AdminRoutes} from "../adminRoutes";

export enum AccessRule {
    READ = 'READ',
    INSERT = 'INSERT',
    ALTER = 'ALTER',
    DELETE = 'DELETE'
}

export type PermissionStateFormType = {
    [key in keyof typeof AdminRoutesPath]: {
        rules: {
            [key in keyof typeof AccessRule]: boolean
        }
    }
}

export const getDisplayNameByKeyRule = (key: string) => {
    switch (key) {
        case AccessRule.READ:
            return 'Leitura';
        case AccessRule.INSERT:
            return 'Inserção';
        case AccessRule.ALTER:
            return 'Alteração';
        case AccessRule.DELETE:
            return 'Exclusão';
        default:
            return '';
    }
}

export const permissionStateForm = (): PermissionStateFormType => {
    let permissionStateForm = {};

    for (const [, value] of Object.entries(AdminRoutesPath)) {
        if( value === 'logoff'){
            continue;
        }

        // @ts-ignore
        permissionStateForm[value] = {
            rules: {
                READ: false,
                INSERT: false,
                ALTER: false,
                DELETE: false
            }
        }
    }

    return permissionStateForm as PermissionStateFormType;
}

export const mergePermissionStringToObject = (permission: string[], object: PermissionStateFormType) => {
    const permissionObject = {...object};

    for (const permissionString of permission) {
        const [routeName, rule] = permissionString.split('@');
        const rules = rule.split('.') as NewRoutesType['rule'];

        for (const [key] of Object.entries(permissionObject)) {
            if (key === routeName) {
                for (const rule of rules) {
                    // @ts-ignore
                    permissionObject[key].rules[rule] = true;
                }
            }
        }
    }

    return permissionObject;
}

export const permissionObjectToString = (permission: PermissionStateFormType) => {
    const permissionString = [];

    for (const [key, value] of Object.entries(permission)) {
        const rules = Object.entries(value.rules).filter(([_, value]) => value).map(([key]) => key);
        permissionString.push(key + "@" + rules.join('.'));
    }

    return permissionString.join(",");
}

type NewRoutesType = RoutesType & {
    rule?: Array<keyof typeof AccessRule>;
}

export type AdminRouteObject = {
    [K in keyof typeof AdminRoutesPath]: NewRoutesType & {
    rule?: Array<keyof typeof AccessRule>;
}
}

export const generateRoute = (route: AdminRouteObject) => {
    const routesArray: NewRoutesType[] = [];

    for (const [, value] of Object.entries(route)) {
        routesArray.push(value);
    }

    return routesArray;
}

export const getDisplayNameByKey = (key: string) => {
     // @ts-ignore
    return AdminRoutes[key].name;
}

export const generatePermission = (route: AdminRouteObject, permissions: string[]) => {
    const routesArray: NewRoutesType[] = [];

    for (const [key, value] of Object.entries(route)) {

        for (const permission of permissions) {
            const [routeName, rule] = permission.split('@');

            if (key === routeName && rule) {
                const rules = rule.split('.') as NewRoutesType['rule'];
                const validateRules = rules.every((rule) => Object.values(AccessRule).includes(rule as AccessRule));

                if (validateRules) {
                    routesArray.push({
                        ...value,
                        rule: rules,
                    });
                }
            }
        }
    }

    return routesArray;
}

export const initialPermission = () => {
    return Object.entries(AdminRoutesPath).map(([value]) => value + "@" + Object.entries(AccessRule).map(([value]) => value).join(".")).join(",");
}
